import * as mutations from '../store/mutations';
import * as constants from '../../common/constants';
import {mapGetters} from 'vuex';
import $ from 'jquery';
import MixinAspsp from '@/common/mixins/aspsp';

/**
 * Base of the CSS ClassName
 * @type {String}
 */
const paymentMethodSepaCssClassName = 'cta-payment-method-sepa';
const paymentMethodCreditCardCssClassName = 'cta-payment-method-credit-card';

/**
 * Selector to retreive elements with the base className
 * @type {String}
 */
const paymentMethodSepaElementSelector = `*[class*="${paymentMethodSepaCssClassName}"]`;
const paymentMethodCreditCardElementSelector = `*[class*="${paymentMethodCreditCardCssClassName}"]`;

export default {
  data() {
    return {
      localePaymentMethod: ''
    };
  },
  mixins: [
    MixinAspsp
  ],
  computed: {
    ...mapGetters([
      'paymentMethod'
    ])
  },
  created() {
    /**
     * Initialize localePaymentMethod with the store one
     */
    this.localePaymentMethod = this.$store.getters.paymentMethod;

    /**
     * Listen a click on a button to changer the paymentMethod
     */
    $('body').on('click', paymentMethodSepaElementSelector, () => {
      this.$store.commit(mutations.SET_PAYMENT_METHOD, constants.PAYMENT_METHOD_SEPA);
      this.setAspspData();
    });

    /**
     * Listen a click on a button to changer the paymentMethod
     */
    $('body').on('click', paymentMethodCreditCardElementSelector, () => {
      this.$store.commit(mutations.SET_PAYMENT_METHOD, constants.PAYMENT_METHOD_BANK_CARD);
      this.setAspspData();
    });
  },
  watch: {
    paymentMethod(value) {
      this.localePaymentMethod = value;
    },
    localePaymentMethod(value) {
      this.$store.commit(mutations.SET_PAYMENT_METHOD, value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/controllers/payment-method.js